import Vue from 'vue'
import Vuex from 'vuex'
import * as change from './modules/change.js'
import * as submission from './modules/submission.js'
import * as entity from './modules/entity.js'
import * as officer from './modules/officer.js'
import * as document from './modules/document.js'
import * as application from './modules/application.js'
import * as user from './modules/user.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    change,
    submission,
    entity,
    officer,
    document,
    application,
    user
  },
  state: {},
  mutations: {},
  actions: {}
})